import React, { useEffect, useState } from "react";
import { Form, CheckboxGroup, Checkbox, Tooltip } from "@douyinfe/semi-ui";
import { CrudOption } from "./crud";

interface DictCheckboxGroupProps {
  field: string;
  options: CrudOption[];
  value?: string;
  onChange?: (value: string) => void;
  label: string;
  /** 旧字典值 → 迁移推荐提示映射 */
  legacyHints?: Record<string, string>;
}

/**
 * 字典多选组件 — 将逗号分隔字符串与 CheckboxGroup 互转
 * Form.CheckboxGroup 提供标签渲染，内部 CheckboxGroup 受控处理字符串/数组转换
 */
export default function DictCheckboxGroup({ field, options, value, onChange, label, legacyHints }: DictCheckboxGroupProps) {
  const [selected, setSelected] = useState<string[]>([]);

  useEffect(() => {
    if (!value) {
      setSelected([]);
    } else {
      setSelected(value.split(",").filter(Boolean));
    }
  }, [value]);

  const handleChange = (vals: string[]) => {
    setSelected(vals);
    onChange?.(vals.join(","));
  };

  return (
    <Form.CheckboxGroup field={field} label={label}>
      <CheckboxGroup
        direction='horizontal'
        value={selected}
        onChange={handleChange}
        style={{ display: "flex", flexWrap: "wrap", gap: 10 }}
      >
        {options.map((opt) => {
          const isLegacy = String(opt.key).startsWith('__legacy_');
          const hint = isLegacy && legacyHints ? legacyHints[String(opt.value)] : null;
          const checkbox = (
            <Checkbox key={opt.key} value={String(opt.value)}>
              <span style={isLegacy ? { color: 'var(--semi-color-warning)' } : undefined}>
                {opt.label}
              </span>
            </Checkbox>
          );
          return isLegacy ? (
            <Tooltip key={opt.key} content={hint ? `建议更新为：${hint}` : '请选择新选项'}>
              {checkbox}
            </Tooltip>
          ) : checkbox;
        })}
      </CheckboxGroup>
    </Form.CheckboxGroup>
  );
}
